import React from "react";

import logo from "../logo.png";
function Header() {
  const getTitle = () => {
    const path = window.location.pathname;
    let title = "Aday Değerlendirme Formu";
    if (path === "/automation") {
      return title;
    } else if (path === "/bilgiislem") {
      return title;
    } else if (path === "/teknisyen") {
      return title;
    } else if (path === "/tobacco") {
      return title;
    } else if (path === "/marketing") {
      return title;
    } else if (path === "/salesengineer") {
      return title;
    } else if (path === "/insankaynaklari") {
      return title;
    } else if (path === "/finansmuhasebe") {
      return title;
    } else if (path === "/kalitesurec") {
      return title;
    } else {
      title = "Candidate Evaluation Form";
      return title;
    }
  };
  return (
    <div className="customHeader">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>
      <div className="title">
        <h2>{getTitle()}</h2>
      </div>
    </div>
  );
}

export default Header;
